import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root bulunamadi')

// StrictMode KULLANILMIYOR geliştirmede ölçüm ekranı için: çift çalıştırma
// deneme döngüsünü iki kez başlatıp zamanlamayı bozuyor. Üretim derlemesinde
// StrictMode zaten çift çalıştırmaz, ama ikisini aynı tutmak için kapalı.
void StrictMode

createRoot(root).render(<App />)
